import { useState, useContext } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import InputConfig from '../../../../../Components/InputConfig';
import { getAspectRatio } from '../../../../../utilities/helpers';

//mui imports==========
import useCommonStyles from '../../../../../commonStyles';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { Grid } from '@mui/material';
//=====================

//Config Component that only configures width and height ( Pass keyData and device Type(["Desktop"|"Mobile"|"Tablet"]) as props )
const WidthAndHeightConfig = ({ keyData, deviceType }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext

	const [aspectRatioData, setAspectRatioData] = useState({
		aspectRatio: '',
		valid: false
	});

	const checkIfValidRatio = () => {
		try {
			const width = rawConfig && rawConfig[keyData + '.width'];
			const height = rawConfig && rawConfig[keyData + '.height'];
			setAspectRatioData(getAspectRatio(width, height));
		} catch (err) {
			console.log('Error is : ', err);
		}
	};

	useEffect(() => {
		if (rawConfig) checkIfValidRatio();
	}, [rawConfig, keyData]);

	return (
		<Grid item xs={3.8} className={commonStyleClasses.basicOutlinedBox} style={{ margin: '.5rem' }}>
			<Grid container spacing={2}>
				<Grid item xs={7}>
					<Typography fontWeight={600} variant="h5">
						{deviceType}
					</Typography>
				</Grid>
				<Grid item xs={5}>
					<Typography fontWeight={600} variant="h6" color={aspectRatioData.valid ? 'green' : 'red'}>
						{aspectRatioData.valid ? aspectRatioData.aspectRatio : 'Not a valid aspect ratio!'}
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<InputConfig
						keyData={keyData + '.width'}
						label="Width"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%' }}
						labelStyles={{ width: '100%' }}
					/>
				</Grid>
				<Grid item xs={12}>
					<InputConfig
						keyData={keyData + '.height'}
						label="Height"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%' }}
						labelStyles={{ width: '100%' }}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default WidthAndHeightConfig;
